var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoogleMapLoader',{attrs:{"mapConfig":_vm.mapConfig,"apiKey":_vm.apiKey,"google":_vm.google},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var google = ref.google;
var map = ref.map;
return [_c('MapLegend',{attrs:{"isInMapSearchPage":true}}),_c('GoogleMapMarkers',{attrs:{"gardens":_vm.gardens,"google":google,"map":map,"addInfoWindows":true}}),_c('GoogleMapMarkerClusterer',{attrs:{"gardens":_vm.gardens,"google":google,"map":map}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }